"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RoleTypeTypes_1 = require("../enums/RoleTypeTypes");
const AuthTypeTypes_1 = require("../enums/AuthTypeTypes");
const rxjs_1 = require("rxjs");
class AuthUtils {
    static getDefaultTimeBeforeExpirationToken() {
        return 30000;
    }
    static decode(token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(atob(base64)) ?? null;
        }
        catch (error) {
            return null;
        }
    }
    static parseToken(token) {
        try {
            const decoded = AuthUtils.decode(token);
            const expiresAt = decoded.exp * 1000;
            const { ownerId, loggedUserId, role, client_id: clientId, email, } = decoded[RoleTypeTypes_1.INFORMATION_KEY];
            const userType = ownerId !== loggedUserId
                ? RoleTypeTypes_1.RoleTypeTypes.ADDITIONAL
                : loggedUserId
                    ? RoleTypeTypes_1.RoleTypeTypes.TITULAR
                    : null;
            const tokenType = Object.keys(decoded[RoleTypeTypes_1.INFORMATION_KEY]).length > 0
                ? AuthTypeTypes_1.AuthTypeTypes.AUTH0
                : AuthTypeTypes_1.AuthTypeTypes.ON_PREMISE;
            return {
                email,
                clientId,
                expiresAt,
                tokenType,
                userType,
                accountId: ownerId ?? '',
                loggedId: loggedUserId ?? '',
                loggedIdEncode: btoa(loggedUserId ?? ''),
                roles: [role ? role : userType],
            };
        }
        catch (e) {
            return {};
        }
    }
    static isTokenExpired(token) {
        const expiresAt = this.getExpirationTimeFromToken(token);
        const currentTime = new Date().getTime();
        return !!expiresAt && currentTime > expiresAt;
    }
    static getExpirationTimeFromToken(token) {
        const decodedAccessToken = this.decode(token);
        return decodedAccessToken?.exp ? decodedAccessToken.exp * 1000 : 0;
    }
    static getUserRoleFromToken(token) {
        const decodedAccessToken = this.decode(token);
        return decodedAccessToken?.[RoleTypeTypes_1.INFORMATION_KEY]?.role ?? '';
    }
    static hasExpirationTimeProperty(token) {
        const decoded = this.decode(token);
        return decoded?.exp !== undefined;
    }
    static timerRenewal(token, isDebugEnabled) {
        const expiresAt = this.getExpirationTimeFromToken(token);
        const currentTime = new Date().getTime();
        if (isDebugEnabled) {
            AuthUtils.processDebugMessage(token, expiresAt, currentTime);
        }
        return (0, rxjs_1.timer)(Math.max(1, expiresAt - currentTime));
    }
    static timerRenewalForRefreshToken(token, isDebugEnabled, timeBeforeRefreshToken) {
        const expiresAt = this.getExpirationTimeFromToken(token);
        const currentTime = new Date().getTime();
        if (isDebugEnabled) {
            AuthUtils.processDebugMessage(token, expiresAt, currentTime);
        }
        if (timeBeforeRefreshToken && timeBeforeRefreshToken < 1) {
            timeBeforeRefreshToken = this.getDefaultTimeBeforeExpirationToken();
        }
        return (0, rxjs_1.timer)(Math.max(1, expiresAt -
            currentTime -
            (timeBeforeRefreshToken ?? this.getDefaultTimeBeforeExpirationToken())));
    }
    static processDebugMessage(token, expiresAt, currentTime) {
        const dueTime = expiresAt - currentTime;
        console.log(`
          Feat: renewToken // ---------------------------------------
          ------ Token               : ${token} \n
          ------ Token current time  : ${currentTime} -- ${new Date(currentTime)} \n
          ------ Token expires at    : ${expiresAt} -- ${new Date(expiresAt)} \n
          ------ Token Renew at      : ${currentTime + dueTime} -- ${new Date(currentTime + dueTime)} \n
          -----------------------------------------------------------
        `);
    }
}
exports.default = AuthUtils;
